module.exports = __webpack_public_path__ + "img/introduction_icon_one@2x.c473bc74.png";